import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarDates = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 10.5 12",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:#231f20;}" }) }),
		/* @__PURE__ */ _jsx("g", {
			id: "Layer_2",
			"data-name": "Layer 2",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Layer_1-2",
				"data-name": "Layer 1",
				children: /* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M10.5,2.62V3.75H0V2.62A1.12,1.12,0,0,1,1.12,1.5H2.25V.38A.38.38,0,0,1,2.62,0h.76a.38.38,0,0,1,.37.38V1.5h3V.38A.38.38,0,0,1,7.12,0h.76a.38.38,0,0,1,.37.38V1.5H9.38A1.12,1.12,0,0,1,10.5,2.62ZM0,4.5H10.5v6.38A1.12,1.12,0,0,1,9.38,12H1.12A1.12,1.12,0,0,1,0,10.88ZM1.5,7.22a.29.29,0,0,0,.28.28h.94A.29.29,0,0,0,3,7.22V6.28A.29.29,0,0,0,2.72,6H1.78a.29.29,0,0,0-.28.28Zm0,3a.29.29,0,0,0,.28.28h.94A.29.29,0,0,0,3,10.22V9.28A.29.29,0,0,0,2.72,9H1.78a.29.29,0,0,0-.28.28Zm3-3a.29.29,0,0,0,.28.28h.94A.29.29,0,0,0,6,7.22V6.28A.29.29,0,0,0,5.72,6H4.78a.29.29,0,0,0-.28.28Zm0,3a.29.29,0,0,0,.28.28h.94A.29.29,0,0,0,6,10.22V9.28A.29.29,0,0,0,5.72,9H4.78a.29.29,0,0,0-.28.28Zm3-3a.29.29,0,0,0,.28.28h.94A.29.29,0,0,0,9,7.22V6.28A.29.29,0,0,0,8.72,6H7.78a.29.29,0,0,0-.28.28Zm0,3a.29.29,0,0,0,.28.28h.94A.29.29,0,0,0,9,10.22V9.28A.29.29,0,0,0,8.72,9H7.78a.29.29,0,0,0-.28.28Z"
				})
			})
		})
	]
});
const ForwardRef = forwardRef(SvgCalendarDates);
export default ForwardRef;
